import { GridColDef } from "@mui/x-data-grid-pro";
import { AddGroupDialog } from "components/alove/AddGroupDialog";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { TwoSizeChip } from "components/alove/Chips";
import { TablePage } from "components/alove/TablePage";
import { setCurrentDialog, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { Group } from "models/profile/Group";
import { useNavigate } from "react-router-dom";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { getGroups, publishGroups } from "utils/groupUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;
import { GroupType } from "models/profile/Group";
import { useState } from "react";
export const GroupsList = () => {
  const [controller, dispatch] = useMaterialUIController();
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
    const columns: GridColDef[] = [
      {
        headerName: "Name",
        field: "name",
        flex: 1,
      },
      {
        headerName: "Description",
        field: "description",
        flex: 1,
      },
      {
        headerName: "Type",
        field: "type",
        flex: 1,
        renderCell: (params) => {
          return <TwoSizeChip label={GroupType[params.row.type]} />;
      },},
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      renderCell: (params) => {
        return <TwoSizeChip label={params.row.statusLabel} color={params.row.statusColor as any} />;
      },
    }
  ];

  const loadGroups = () => getGroups();

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Groups" />
      <TablePage
        actions={{
          title: "Groups actions",
          addActions: [
            {
              label: "Group",
              onClick: () => setCurrentDialog(dispatch, DialogType.AddGroup),
              variant: "contained",
              color: "secondary",
            }
          ],
        }}
        refresh={refresh}
        table={{
          loadNext: loadGroups,
          columns,
          lineClick: (group) => !isNaN(group.id) && navigate(`/groups/${group.id}`),
          
        }}
        title="Groups"
      />
      <AddGroupDialog onAdd={() => setRefresh(!refresh)} />
    </DashboardLayout>
  );
};
